export default __webpack_public_path__ + "static/media/hughes.706aeda0.png";